// extracted by mini-css-extract-plugin
module.exports = {"background-layer":"BackgroundLayer-module__background-layer___1jivC","restrict-height":"BackgroundLayer-module__restrict-height___8vuvQ"};